import { render, staticRenderFns } from "./DiscussionBoardItem.vue?vue&type=template&id=75b6a5cf&"
import script from "./DiscussionBoardItem.vue?vue&type=script&lang=js&"
export * from "./DiscussionBoardItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports